/**
 * Add days to existing Date, returning a new Date
 * @param {Date} date
 * @param {Number} days
 * @returns {Date} new Date w/ days added
 */
export function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function genRandomString(len) {
  var p = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return [...Array(len)].reduce(a => a + p[~~(Math.random() * p.length)], '');
}

export function truncateString(str, n) {
  return str.length > n ? str.slice(0, n - 1) + '...' : str;
}

export function genCreditsLiteral(credits) {
  if (!credits && credits !== 0) {
    return null;
  }

  if (credits === 1) {
    return '1 Punkt';
  }
  return `${credits} Punkte`;
}

export function getRoleLiteral(role) {
  if (role === 'admin') {
    return 'Administrator';
  }
  if (role === 'trainer') {
    return 'Trainer';
  }
  if (role === 'user') {
    return 'Benutzer';
  }
  if (role === 'deactivated') {
    return 'Deaktiviert';
  }
  return '';
}

export function getCurrencySymbol(currency) {
  if (!currency) {
    return '';
  }
  if (currency === 'euro') {
    return 'EUR';
  }
  if (currency === 'chf') {
    return 'CHF';
  }
}
